var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHelp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    fill: "#000000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 16,32c 8.836,0, 16-7.164, 16-16s-7.164-16-16-16S0,7.164,0,16S 7.164,32, 16,32z M 16,4c 3.982,0, 8,2.28, 8,7.376 c0,2.966-1.47,5.282-4.368,6.876C 18.792,18.714, 18,19.628, 18,20c0,1.104-0.896,2-2,2s-2-0.896-2-2c0-2.538, 2.328-4.496, 3.704-5.252 C 19.726,13.632, 20,12.416, 20,11.376C 20,8.438, 17.494,8, 16,8C 14.074,8, 12,9.264, 12,12.042c0,1.104-0.896,2-2,2s-2-0.896-2-2 C 8,6.818, 12.122,4, 16,4z M 16,28.088c-1.138,0-2.060-0.922-2.060-2.060s 0.922-2.060, 2.060-2.060s 2.060,0.922, 2.060,2.060S 17.138,28.088, 16,28.088z "
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelp);
export default __webpack_public_path__ + "static/media/help.d531a2f68dd4599322aa8144acd5aab3.svg";
export { ForwardRef as ReactComponent };